var _circle, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOurPolicies(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#E2FFCC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5578_77",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 9,
    width: 14,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 9.81299H24.5V26.1867H11.5V9.81299Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5578_77)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.009 10.6812C12.009 10.462 12.1737 10.2899 12.3895 10.2784H12.4125H23.5876C23.8145 10.2784 23.991 10.4549 23.991 10.6818V25.3188C23.991 25.5457 23.8145 25.7223 23.5876 25.7223H12.4125C12.1855 25.7223 12.009 25.5458 12.009 25.3188V10.6812ZM12.4125 9.68799C11.8649 9.68799 11.4194 10.1344 11.4194 10.681V25.318C11.4194 25.8656 11.8659 26.311 12.4125 26.311H23.5876C24.135 26.311 24.5814 25.8648 24.5814 25.318V10.681C24.5814 10.1334 24.1349 9.68799 23.5876 9.68799H12.4125Z",
    fill: "#367B00",
    stroke: "#367B00",
    strokeWidth: 0.25
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9014 23.094L20.9453 23.8716L20.7929 23.6629L20.5176 23.8629L20.881 24.3627L22.1156 23.3582L21.9014 23.094Z",
    fill: "#367B00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3253 22.2466C20.5477 22.2466 19.9209 22.9028 19.9209 23.6994C19.9209 24.496 20.5485 25.1522 21.3253 25.1522C22.1029 25.1522 22.7298 24.496 22.7298 23.6994C22.7298 22.9028 22.1021 22.2466 21.3253 22.2466ZM21.3253 22.587C21.9117 22.587 22.3901 23.0797 22.3901 23.7002C22.3901 24.3207 21.9117 24.8134 21.3253 24.8134C20.739 24.8134 20.2605 24.3207 20.2605 23.7002C20.2605 23.0797 20.739 22.587 21.3253 22.587Z",
    fill: "#367B00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8749 12.0569H22.4212C22.5219 12.0569 22.6037 12.1386 22.6037 12.2394V12.3465C22.6037 12.4473 22.5219 12.529 22.4212 12.529H13.8749C13.7741 12.529 13.6924 12.4473 13.6924 12.3465V12.2394C13.6924 12.1386 13.7741 12.0569 13.8749 12.0569Z",
    fill: "#367B00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8749 14.7126H22.4212C22.5219 14.7126 22.6037 14.7944 22.6037 14.8951V15.0023C22.6037 15.103 22.5219 15.1848 22.4212 15.1848H13.8749C13.7741 15.1848 13.6924 15.103 13.6924 15.0023V14.8951C13.6924 14.7944 13.7741 14.7126 13.8749 14.7126Z",
    fill: "#367B00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8749 17.3677H22.4212C22.5219 17.3677 22.6037 17.4494 22.6037 17.5502V17.6573C22.6037 17.7581 22.5219 17.8398 22.4212 17.8398L13.8749 17.8406C13.7741 17.8406 13.6924 17.7589 13.6924 17.6581V17.551C13.6924 17.4502 13.7741 17.3685 13.8749 17.3685V17.3677Z",
    fill: "#367B00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0134 20.0234H22.4212C22.5219 20.0234 22.6036 20.1052 22.6036 20.2059V20.313C22.6036 20.4138 22.5219 20.4955 22.4212 20.4955H15.0126C14.9118 20.4955 14.8301 20.4138 14.8301 20.313V20.2059C14.8301 20.1052 14.9118 20.0234 15.0126 20.0234H15.0134Z",
    fill: "#367B00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurPolicies);
export default __webpack_public_path__ + "static/media/ourPolicies.030064a3bc025c0122c50e029dc15b1a.svg";
export { ForwardRef as ReactComponent };